var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-class"},[_c('v-tabs',{attrs:{"color":"black","dark":"","slider-color":"primary"}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Utilisateurs")])],1),_vm._v(" "),_c('pro-user-list',{attrs:{"url":"proUsers"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc46f27e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/proUsers/proUser.list.vue
// module id = null
// module chunks = 